import React, { useState } from 'react';
import { Upload, X, Loader2, Plus } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { imagesAPI } from '../../services/api';

const MAX = 10;

export const BackgroundImagesUploader = ({ value = [], onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [link, setLink] = useState('');
  const [error, setError] = useState('');

  const handleFiles = async (e) => {
    const files = Array.from(e.target.files || []).slice(0, MAX - value.length);
    e.target.value = '';
    if (!files.length) return;
    setUploading(true); setError('');
    const added = [];
    for (const f of files) {
      try {
        const res = await imagesAPI.upload(f, '', 'formularios');
        added.push(res.url);
      } catch (err) {
        setError(err.response?.data?.detail || `Falha ao enviar ${f.name}`);
      }
    }
    onChange([...value, ...added].slice(0, MAX));
    setUploading(false);
  };

  const addLink = () => {
    const u = link.trim();
    if (!/^https?:\/\//i.test(u)) { setError('O link deve começar com http:// ou https://'); return; }
    onChange([...value, u].slice(0, MAX)); setLink(''); setError('');
  };

  const full = value.length >= MAX;
  return (
    <div className="space-y-2" data-testid="bg-images-uploader">
      <div className="grid grid-cols-5 gap-2">
        {value.map((u, i) => (
          <div key={u + i} className="relative aspect-square rounded-md overflow-hidden border bg-gray-100">
            <img src={u} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))}
              data-testid={`bg-image-remove-${i}`}
              className="absolute top-1 right-1 bg-black/60 hover:bg-red-600 text-white rounded-full p-0.5">
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        {!full && (
          <label className="aspect-square rounded-md border-2 border-dashed border-gray-300 hover:border-orange-400 flex flex-col items-center justify-center cursor-pointer text-gray-500 text-[10px]" data-testid="bg-image-upload-label">
            {uploading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Upload className="w-5 h-5" />}
            <span className="mt-1">{uploading ? 'Enviando...' : 'Enviar'}</span>
            <input type="file" accept="image/jpeg,image/png,image/webp" multiple className="hidden"
              disabled={uploading} onChange={handleFiles} data-testid="bg-image-file-input" />
          </label>
        )}
      </div>
      <p className="text-xs text-gray-500" data-testid="bg-images-count">{value.length}/{MAX} imagens · trocam aleatoriamente no fundo</p>
      {!full && (
        <div className="flex gap-2">
          <Input value={link} onChange={(e) => setLink(e.target.value)} placeholder="ou cole um link https://..." data-testid="bg-image-link-input" />
          <Button type="button" variant="outline" onClick={addLink} data-testid="bg-image-link-add"><Plus className="w-4 h-4" /></Button>
        </div>
      )}
      {error && <p className="text-xs text-red-600" data-testid="bg-images-error">{error}</p>}
    </div>
  );
};
